import * as React from 'react';
import { observer } from 'mobx-react';
import { IOptimizerArrowParams } from './IOptimizerArrowParams';
import * as d3 from 'd3';

@observer
export class OptimizerArrow extends React.Component<IOptimizerArrowParams> {
  constructor(props: IOptimizerArrowParams) {
    super(props, undefined);
  }

  render() {
    let arrowData = [
      { x: 0, y: 0 },
      { x: 20, y: -20 },
      { x: 85, y: -20 },
      { x: 85, y: 20 },
      { x: 20, y: 20 },
      { x: 0, y: 0 },
    ];

    let lineFunction = d3.svg
      .line<{
        x: number;
        y: number;
      }>()
      .x(function(d) {
        return d.x;
      })
      .y(function(d) {
        return d.y;
      })
      .interpolate('linear');

    let colorOfTheArrow =
      this.props.valueOnArrow &&
      this.props.minInputValueForBarRange &&
      this.props.maxInputValueForBarRange &&
      this.props.valueOnArrow >= this.props.minInputValueForBarRange &&
      this.props.valueOnArrow <= this.props.maxInputValueForBarRange
        ? '#367FC0'
        : '#EC691A';
    var textForArrowXPosition = 20;
    var textForArrowYPosition = 7;

    return (
      <g className="OptimizerArrow">
        {this.props.valueOnArrow != null && (
          <path
            className="arrowShape"
            d={lineFunction(arrowData)}
            stroke="#fff"
            strokeWidth="1"
            fill={colorOfTheArrow}
            y="100"
          ></path>
        )}
        <text
          className="arrowText"
          x="30"
          transform={`translate(${textForArrowXPosition},${textForArrowYPosition})`}
        >
          {this.props.valueOnArrowText}
        </text>
      </g>
    );
  }
}
